import { isSet, wOrgIdMiddleware } from '../utils/commonUtils';
import { OK } from '../utils/constant';
// import OrganizationService from './OrganizationService';
import http from './http';


const DropDownService = {
  getGlobalSearchDropDown: wOrgIdMiddleware(async (url, query) => {
    const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}globalSearch?${queryString}`);
      return response.data;
    } catch (error) {
      // console.error('Error fetching company:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

    }
  }, true),

    getOrganizationDropDownList:async(query='')=>{
        try {
          const queryString = new URLSearchParams(query).toString();
            const response = await http.GET(`get-dropdown/organizations?${queryString}`);
            
              if (response.code===OK) {
                return response.data;
              }
            
          } catch (error) {
            console.error('Error fetching user:', error);
            if(error.status){
              const resData = error.data;
              if(resData.code && resData.data){
                  return resData;
              }
            }
            
            // throw error;
          } 
    },
  getCompanies: wOrgIdMiddleware(async (url) => {
    try {
    //   const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`${url}get-dropdown/company`);
      
        if (response.code === OK) {
          return response.data;
        }
      
    } catch (error) {
      // console.error('Error fetching company:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

    }
  },true),

  getLabsforClinic:wOrgIdMiddleware(async(url,query) => {
    const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`${url}get-dropdown/labsForClinic?${queryString}`);
            
        if (response.code === OK) {
          return response.data;
        }
 
    } catch (error) {
      // console.error('Error fetching company:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

    }
  },true),
  getAssignCompanyOptionsForSelfRegister: async (clinic_id) => {
    try {
    //   const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`get-dropdown/assign_company/${clinic_id}`);
      console.log('company options for self register',response);
        if (response.code === OK) {
          return response.data;
        }
      
    } catch (error) {
      // console.error('Error fetching company:', error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

    }
  },
  
  getClinicList: wOrgIdMiddleware(async (url) => {
    try {
      
      const response = await http.GET(`${url}get-dropdown/clinic`);
      
        if(response.code===200 && response.data){
          return response.data;
        }
      
      return null;
    } catch (error) {
      console.error('Error fetching user:', error);
      // throw error;
    }
  },true),
  getClinicListForSelfRegistration: async (value="") => {
    try {
      const response = await http.GET(`get-dropdown-self-registration/clinics?value=${value}`);
      // console.log('drop self regs',response);
        if(response.code===200 && response.data){
          return response.data;
        }
      
      return null;
    } catch (error) {
      console.error('Error fetching user:', error);
      // throw error;
    }
  },
  getClinicLocationsForSelfRegistration: async (clinic_id) => {
    try {
      const response = await http.GET(`get-dropdown-self-registration/clinicLocation/${clinic_id}`);
      
        if(response.code===200 && response.data){
          return response.data;
        }
      
      return null;
    } catch (error) {
      console.error('Error fetching user:', error);
      // throw error;
    }
  },

  getInsuranceDropDownSelfRegisteration: async () => {
    try {
      const response = await http.GET(`get-dropdown-self-registration/insurance`);
      if (response.code === OK) {
        return response;
      }
      else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching Insurance:', error);
    }
  },
  
  getLabsList: wOrgIdMiddleware(async (url) => {
    
    try {

      const response = await http.GET(`${url}get-dropdown/labs`);
      
        if (response.code === 200 && response.data) {
          return response.data;
        }
      
      return null;
    } catch (error) {
      // console.error('Error fetching user:', error);
      throw error;
    }
  }, true),
  getProvidersDropdownList: wOrgIdMiddleware(async (url, query = {}) => {
    // const queryString = new URLSearchParams(query).toString();
    try {
        // const orgId       = OrganizationService.getOrgId();
        const response = await http.GET(`${url}get-dropdown/providers`);
        
            if (response.code === OK) {
                return response.data;
            }
        
    } catch (error) {
        // console.error('Error fetching provider:', error);
        if (error.status) {
            const resData = error.data;
            if (resData.code && resData.data) {
                return resData;
            }
        }

        // throw error;
    }
},true),
getActivityDropdownList: wOrgIdMiddleware(async (url,query={}) => {
  const queryString = new URLSearchParams(query).toString();
  try {
      const response = await http.GET(`${url}get-dropdown/activity?${queryString}`);
      if (response.code === OK) {
          return response.data;
      }
      
  } catch (error) {
      // console.error('Error fetching provider:', error);
      if (error.status) {
          const resData = error.data;
          if (resData.code && resData.data) {
              return resData;
          }
      }

      // throw error;
  }
},true),
getActivityDropdownListForLabOrder: (async (query={}) => {
  const queryString = new URLSearchParams(query).toString();
  console.log('queryString',queryString);
  try {
      const response = await http.GET(`organizations/null/get-dropdown/activity?${queryString}`);
      if (response.code === OK) {
          return response.data;
      }
      
  } catch (error) {
      // console.error('Error fetching provider:', error);
      if (error.status) {
          const resData = error.data;
          if (resData.code && resData.data) {
              return resData;
          }
      }

      // throw error;
  }
}),
getActivityDropdownListforPricing: wOrgIdMiddleware(async (url,query={}) => {
  try {
    const queryString = new URLSearchParams(query).toString();
    const response = await http.GET(`${url}get-dropdown/pricing-activities?${queryString}`);
      if (response.code === OK) {
          return response.data;
      }
      
  } catch (error) {
      // console.error('Error fetching provider:', error);
      if (error.status) {
          const resData = error.data;
          if (resData.code && resData.data) {
              return resData;
          }
      }

      // throw error;
  }
},true),
getTimeZoneDropdownList: async (url, query = {}) => {
  try {
      // const queryString = new URLSearchParams(query).toString();
      const response = await http.GET(`/organizations/org_id/get-dropdown/timezone`);
      let options=[{label:'--Select Timezone--',value:''}];
      
          if (response.code === OK) {
            let dropdownOptions=response.data;
            if (dropdownOptions) {
             isSet(dropdownOptions,[]).forEach((item,index) => {
                options.push({label:item.time_zone_name,value:item.time_zone}); 
              });
            }
              return options;
          }
      
  } catch (error) {
      // console.error('Error fetching provider:', error);
      if (error.status) {
          const resData = error.data;
          if (resData.code && resData.data) {
              return resData;
          }
      }

      // throw error;
  }
},
getBasicPhysicalDropdownList: wOrgIdMiddleware(async (url) => {
  try {
    
    const response = await http.GET(`${url}get-dropdown/basic-physicals`);
    
      if(response.code===200 && response.data){
        return response.data;
      }
    
    return null;
  } catch (error) {
    console.error('Error fetching user:', error);
    // throw error;
  }
},true),
getClinicDropDownListByCompany: wOrgIdMiddleware(async (url,query={}) => {
  try {
    const queryString = new URLSearchParams(query).toString();
    const response = await http.GET(`${url}get-dropdown/clincsByCompany?${queryString}`);

      if(response.code===200 && response.data){
        return response.data;
      }

    return null;
  } catch (error) {
    console.error('Error fetching user:', error);
    // throw error;
  }
},true),
  getEmployeeList: wOrgIdMiddleware(async (url) => {
    try {
      const response = await http.GET(`${url}get-dropdown/employee`);
      if (response.code === 200 && response.data) {
        return response.data;
      }

      return null;
    } catch (error) {
      console.error('Error fetching user:', error);
      // throw error;
    }
  }, true),
  /** Employees filtered by companies assigned to the current user (data sharing) */
  getEmployeeListByUserCompanies: wOrgIdMiddleware(async (url) => {
    try {
      const response = await http.GET(`${url}get-dropdown/employee-by-user-companies`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching employees by user companies:', error);
      return null;
    }
  }, true),
  getSftpConfigList: wOrgIdMiddleware(async (url) => {
    try {
      const response = await http.GET(`${url}get-dropdown/sftp-config`);
      if (response.code === 200 && response.data) {
        return response.data;
      }

      return null;
    } catch (error) {
      console.error('Error fetching user:', error);
      // throw error;
    }
  }),
  getWorkCompDropDown: wOrgIdMiddleware(async (url) => {
    try {
      const response = await http.GET(`${url}get-dropdown/workcomp`);
      if (response.code === 200 && response.data) {
        return response.data;
      }

      return null;
    } catch (error) {
      console.error('Error fetching user:', error);
      // throw error;
    }
  }),
  getCptDropDown: async () => {
    try {
      const response = await http.GET(`organizations/null/get-dropdown/cpt`);
      return response;
    } catch (error) {
      console.error('Error fetching user:', error);
      // throw error;
    }
  },
  getActivityTypeDropdown: () => {
    return [
      { label: '-Select Activity Type-', value: '' },
      { label: 'Employer Services', value: 'EMPLOYER_SERVICES' },
      { label: 'Workcomp', value: 'WORKCOMP' }
    ];
  },
  // Get employee list for patient forms (public route, no authentication required)
  getEmployeeListForPatientForm: async (organizationUuid) => {
    try {
      const queryString = new URLSearchParams({ organization_uuid: organizationUuid }).toString();
      const response = await http.GET(`patient-form-employee-list?${queryString}`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching employee list for patient form:', error);
      return null;
    }
  },
  // Get companies list for patient forms (public route, no authentication required)
  getCompaniesListForPatientForm: async (organizationUuid) => {
    try {
      const queryString = new URLSearchParams({ organization_uuid: organizationUuid }).toString();
      const response = await http.GET(`patient-form-companies-list?${queryString}`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching companies list for patient form:', error);
      return null;
    }
  },
  // Get clinics by company for patient forms (public route, no authentication required)
  getClinicsByCompanyForPatientForm: async (companyId, organizationUuid) => {
    try {
      const queryString = new URLSearchParams({ 
        company_id: companyId,
        organization_uuid: organizationUuid 
      }).toString();
      const response = await http.GET(`patient-form-clinics-by-company?${queryString}`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching clinics by company for patient form:', error);
      return null;
    }
  },
  // Get clinic departments by clinic for patient forms (public route, no authentication required)
  getClinicDepartmentsByClinicForPatientForm: async (clinicId) => {
    try {
      const queryString = new URLSearchParams({ clinic_id: clinicId }).toString();
      const response = await http.GET(`patient-form-clinic-departments-by-clinic?${queryString}`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching clinic departments for patient form:', error);
      return null;
    }
  },
};

export default DropDownService;
